// src/components/dashboard/RoleBasedDashboard.tsx
import React from 'react';
import { useAuthStore } from '../../store/authStore';
import DashboardRektor from '../../pages/dashboard/DashboardRektor';
import DashboardWarek from '../../pages/dashboard/DashboardWarek';
import DashboardDekan from '../../pages/dashboard/DashboardDekan';
import DashboardKaprodi from '../../pages/dashboard/DashboardKaprodi';
import DashboardLPM from '../../pages/dashboard/DashboardLPM';
import DashboardAdmin from '../../pages/dashboard/DashboardAdmin';

const RoleBasedDashboard: React.FC = () => {
  const { user } = useAuthStore();

  if (!user || !user.role) {
    return <DashboardAdmin />;
  }

  const roleName = user.role.name?.toLowerCase() || '';

  if (roleName === 'rektor') {
    return <DashboardRektor />;
  }

  if (roleName.startsWith('wakil_rektor')) {
    return <DashboardWarek />;
  }

  if (roleName === 'dekan') {
    return <DashboardDekan />;
  }

  if (roleName === 'kaprodi' || roleName === 'kabag' || roleName === 'ka_tu' || roleName === 'kalem') {
    return <DashboardKaprodi />;
  }

  if (roleName === 'lpm') {
    return <DashboardLPM />;
  }

  if (roleName === 'admin' || roleName === 'administrator') {
    return <DashboardAdmin />;
  }

  return <DashboardKaprodi />;
};

export default RoleBasedDashboard;
